import { maxGuestCount } from "./bookingConfig";
import { getSessionStorageValue, STORAGE_KEYS } from "./SessionStorage";

export { maxGuestCount };
export const GUEST_MIN = 1;
export const GUEST_MAX = maxGuestCount;
export const PRIMARY_GUEST_ID = 1;

/**
 * Initial member list: primary guest for single (1) and group (2) booking flows.
 */
export function getPrimaryGuestName() {
  const primaryCustomer = getSessionStorageValue(STORAGE_KEYS.PRIMARY_CUSTOMER);
  if (typeof primaryCustomer === "string" && primaryCustomer.trim()) {
    return primaryCustomer.trim();
  }
  return "Me";
}

export function createInitialGuests() {
  return [
    {
      id: PRIMARY_GUEST_ID,
      name: getPrimaryGuestName(),
      displayName: "Guest 1",
      isPrimary: true,
      services: [],
    },
  ];
}

export function nextGuestId(members) {
  if (!Array.isArray(members) || members.length === 0) return PRIMARY_GUEST_ID + 1;
  return Math.max(...members.map((m) => m.id ?? 0)) + 1;
}

/**
 * After load from session: ensure shape and arrays.
 */
export function normalizeMembersList(raw) {
  if (!Array.isArray(raw) || raw.length === 0) return createInitialGuests();
  const base = raw.map((m, i) => ({
    id: typeof m.id === "number" ? m.id : i + 1,
    isPrimary: i === 0,
    services: Array.isArray(m.services) ? m.services : [],
    name: m.name,
    displayName: m.displayName,
    customerName:
      typeof m.customerName === "string"
        ? m.customerName
        : typeof m.customName === "string"
        ? m.customName
        : "",
  }));
  return reindexGuestLabels(base);
}

/**
 * Re-assign displayName / name for non-primary guests after add/remove (Guest 1, Guest 2, …).
 */
export function reindexGuestLabels(members) {
  if (!Array.isArray(members)) return [];
  let guestNum = 1;
  return members.map((m) => {
    if (m.isPrimary) {
      return { ...m, name: getPrimaryGuestName(), displayName: "Guest 1" };
    }
    const label = `Guest ${guestNum}`;
    guestNum += 1;
    const customerName = (m.customerName || "").trim();
    // Preserve custom guest names in `name` so downstream consumers that still
    // read `member.name` stay in sync with rename edits.
    if (customerName) {
      return { ...m, name: customerName, displayName: label };
    }
    return { ...m, name: label, displayName: label };
  });
}

/** Header chip on Select Services: "Me" for primary, else "Guest 1" etc. */
export function guestHeaderLabel(member) {
  if (!member) return "";
  const customerName = (member.customerName || "").trim();
  if (customerName) return customerName;
  if (member.isPrimary) return getPrimaryGuestName();
  return member.name || member.displayName || "Guest";
}

/** @deprecated use guestHeaderLabel — kept for existing imports */
export const guestDisplayName = guestHeaderLabel;
